export enum Priority {
  low,
  medium,
  high
}

export function getPriorityName(p: Priority) {
  switch (p) {
    case Priority.low:
      return 'Низкий';
    case Priority.medium:
      return 'Средний';
    case Priority.high:
      return 'Высокий';
    default:
      return '';
  }
}

export const PriorityOptions = [
  { label: getPriorityName(Priority.low), id: Priority.low },
  { label: getPriorityName(Priority.medium), id: Priority.medium },
  { label: getPriorityName(Priority.high), id: Priority.high }
];
